import ko from 'knockout';

// Prepend http if no valid scheme present
ko.extenders.prependHttp = function(target) {
    target.subscribe(function(val) {
        if (
            val &&
            val.indexOf('http://') !== 0 &&
            val.indexOf('https://') !== 0
        ) {
            target(`http://${val}`);
        }
    });
    return target;
};

// Notify subscribers of value every <option> ms
// Useful for e.g. triggering automatic relative date value updates
// If <option> is a function, it's passed the target every interval, and
// should return the next notify interval. Returning 0 will result in no
// further updates.
ko.extenders.notifyEvery = function(target, option) {
    let nextInterval;
    if (typeof option === 'function') {
        nextInterval = option(ko.unwrap(target));
    } else {
        nextInterval = option;
    }

    if (!nextInterval) {
        return;
    }

    setTimeout(function() {
        target.notifySubscribers(target.peek());
        // Set next interval
        ko.extenders.notifyEvery(target, option);
    }, nextInterval);
};

// Limit length of characters, and provide computed with count remaining
ko.extenders.maxLength = function(target, length) {
    const res = ko.computed({
        read: target,
        write(val) {
            if (val && val.length > length) {
                val = val.substring(0, length);
            }
            target(''); // Force value change to stop going over max length
            target(val);
        },
    });

    res.charactersLeft = ko.pureComputed(function() {
        if (!res()) {
            return length;
        }
        return length - res().length;
    });

    res(target());

    return res;
};
